import type React from "react";
import type { FormulaScope } from "./api";

/** The tint of a field token: its object's colour, lightened behind and darkened for the text. */
export function fieldStyle(color?: string | null): React.CSSProperties {
    const base = color || "#6b7280";
    const background = `color-mix(in srgb, ${base} 14%, white)`;
    return {
        color: `color-mix(in srgb, ${base} 62%, black)`,
        backgroundColor: background,
        // A shadow, not a padding: the coloured text must keep the width of the typed one.
        boxShadow: `0 0 0 2px ${background}`,
        borderRadius: 3
    };
}

/** « this case », « the opportunity being filtered »: who a scope is, from the condition. */
export function describeScope(scope: FormulaScope, count: number): string {
    const name = scope.name.toLowerCase();
    if (scope.index === count - 1) return `this ${name}`;
    if (scope.index === 0) return `the ${name} being filtered`;
    return `the ${name} it belongs to`;
}
